import { Handle, Position, useStore } from 'reactflow';
import {
  Badge,
  CreditCard,
  Description,
  FlightTakeoff,
  PlayArrow,
  QrCode,
  School,
} from '@mui/icons-material';

const iconMap = {
  start: <PlayArrow className="text-white text-lg" />,
  qr: <QrCode className="text-white text-lg" />,
  terms: <Description className="text-white text-lg" />,
  identity: <CreditCard className="text-white text-lg" />,
  permit: <Badge className="text-white text-lg" />,
  passport: <FlightTakeoff className="text-white text-lg" />,
  tutorial: <School className="text-white text-lg" />,
};

const connectionNodeIdSelector = state => state.connectionNodeId;

function CustomNode({ data, id }) {
  const connectionNodeId = useStore(connectionNodeIdSelector);
  const isTarget = connectionNodeId && connectionNodeId !== id;

  const getNodeStyle = nodeName => {
    const name = nodeName.toLowerCase();
    if (name.includes('start'))
      return {
        bg: 'bg-gradient-to-br from-blue-500 to-indigo-600',
        border: 'border-blue-400',
        shadow: 'shadow-blue-200',
      };
    if (name.includes('qr') || name.includes('authentication'))
      return {
        bg: 'bg-gradient-to-br from-green-500 to-emerald-600',
        border: 'border-green-400',
        shadow: 'shadow-green-200',
      };
    if (name.includes('terms') || name.includes('conditions'))
      return {
        bg: 'bg-gradient-to-br from-amber-500 to-orange-600',
        border: 'border-amber-400',
        shadow: 'shadow-amber-200',
      };
    if (name.includes('tutorial'))
      return {
        bg: 'bg-gradient-to-br from-purple-500 to-violet-600',
        border: 'border-purple-400',
        shadow: 'shadow-purple-200',
      };
    if (
      name.includes('identity') ||
      name.includes('permit') ||
      name.includes('passport')
    )
      return {
        bg: 'bg-gradient-to-br from-slate-600 to-gray-700',
        border: 'border-slate-400',
        shadow: 'shadow-slate-200',
      };
    return {
      bg: 'bg-gradient-to-br from-gray-500 to-gray-600',
      border: 'border-gray-400',
      shadow: 'shadow-gray-200',
    };
  };

  const icon = Object.entries(iconMap).find(([key]) =>
    data.name.toLowerCase().includes(key),
  )?.[1];
  const nodeStyle = getNodeStyle(data.name);

  return (
    <div
      className={`custom-node ${nodeStyle.bg} ${nodeStyle.border} ${nodeStyle.shadow} text-white rounded-xl shadow-lg border-2 p-4 w-52 transition-all duration-200 hover:shadow-2xl hover:border-[#00387D]`}
    >
      <div className="flex items-center gap-3">
        {icon && <span className="flex-shrink-0">{icon}</span>}
        <span className="font-semibold text-sm truncate">{data.name}</span>
      </div>

      {/* Handles */}
      <Handle
        type="source"
        position={Position.Right}
        className="w-4 h-4 bg-white border-2 border-[#E5E7EB] rounded-full hover:border-gray-400 transition-colors"
        style={{ right: '-8px' }}
      />
      <Handle
        type="target"
        position={Position.Left}
        className={`w-4 h-4 bg-white border-2 rounded-full hover:border-gray-400 transition-colors ${
          isTarget ? 'border-dashed border-gray-400' : 'border-[#E5E7EB]'
        }`}
        style={{ left: '-8px' }}
      />
    </div>
  );
}

export default CustomNode;
